import {useInfiniteScroll, useRequest} from "ahooks";
import {Box, Stack, Typography, useTheme} from "@mui/material";
import { getAddressList } from '@/services/user'
import { PageTitle } from '@/styles/CommonSx'
import {getUrlParams} from "@/utils/utils";
import AppLoadingButton from "@/components/mui/LoadingButton";
import {useTranslation} from "react-i18next";
import {createSearchParams, useNavigate, useSearchParams} from "react-router-dom";
import RouteConstant from "@/constant/RouteConstant";
import React, {useRef} from "react";
import PageBack from "@/components/PageBack";
import RpIcon from "@/components/RpIcon";
import {deleteWithdrawAddress} from "@/services/user";
import TransItem from "@/components/skeleton/TransItem";
import Empty from "@/components/Empty.tsx";
import mobileClasses from "@/pages/cards/CardApplyOrderList/mobile.module.css";
import { useConfirm } from "material-ui-confirm";

import classes from "@/pages/cards/CardApplyOrderList/index.module.less";
import LoadMore from "@/components/LoadMore";
import CopyButton from "@/components/CopyButton";
import {useSelector} from "react-redux";
import { setWithdrawInfo } from "@/redux/slices/assets";
import withdraw from "@/pages/Withdraw/Withdraw";
import {dispatch} from "@/redux/store";
import SimpleHeader from "@/pages/components/Headers/SimpleHeader";

const AddressBook = () => {
  const paramVarietyCode = getUrlParams("variety_code");
  const paramCoin = getUrlParams("coin");
  const paramDisplayName = getUrlParams("display_name");
  const confirm = useConfirm();
  const {t} = useTranslation();
  const navigate = useNavigate();
  const ref = useRef(null);

  const { withdrawInfo } = useSelector((state) => state.assets);
  const theme = useTheme();

  const [searchParams, setsearchParams] = useSearchParams()

  const getAddressListReq = useRequest(async () => {
    const res = await getAddressList({
      varietyCode: paramVarietyCode,
      coin: paramCoin,
      pageNum: 1,
      pageSize: 10,
    })
    return res
  })

  const deleteWithdrawAddressReq = useRequest(async (sn) => {
    const res = await deleteWithdrawAddress({
      sn
    })
    return res
  }, { manual: true })

  const getList = async (current = 1) => {
    let res
    try {
      res =  await getAddressList({
        varietyCode: paramVarietyCode,
        coin: paramCoin,
        pageNum: current,
        pageSize: 10,
      })
    } catch (e) {

    }

    const result = {
      list: res?.list || [],
      total: res?.total || 0,
      page: current,
    };
    return result;
  }

  const {data, loading, loadMore, loadingMore, noMore, reload, reloadAsync} = useInfiniteScroll((d) => {
    const page = d ? d.page + 1 : 1
    return getList(page);
  }, {
    manual: false,
    target: ref,
    threshold: 300,
    isNoMore: (d) => {
      return (d && d.list.length >= d.total)
    }
  });
  const hasMore = data && data.list.length < data.total;

  const doConfirm = (item) => {
    confirm({
      title: '',
      description: t("delete_this_address") })
      .then(() => {
        deleteWithdrawAddressReq.runAsync(item.sn).then(() => {
          reloadAsync()
        })
      })
      .catch(() => {
        /* ... */
      });
  }

  const onSelectAddress = (item) => {
    dispatch(setWithdrawInfo({
      ...withdrawInfo,
      address: item.withdrawAddress,
    }))
    navigate(-1)
  }

  return (<>
    <Stack
      sx={{ width: '100%', height: '100%' }}
    >
      <SimpleHeader />
      <Typography fontSize={'28px'} fontWeight={700} sx={{padding: '0 16px'}}>{t('address_book')}</Typography>
      <Stack
             direction="row" gap='10px'
             sx={{
               marginTop: '32px',
               padding: '0 16px',
      }}>
        <Typography
          fontSize={'12px'}
          fontWeight={500}
          sx={theme => {
            return {
              backgroundColor: theme.palette.background.paper,
              color: theme.palette.text.secondary,
              padding: '4px 8px'
            }
          }}
        >{paramVarietyCode?.toUpperCase()}</Typography>
        <Typography
          fontSize={'12px'}
          fontWeight={500}
          sx={theme => {
            return {
              backgroundColor: theme.palette.background.paper,
              color: theme.palette.text.secondary,
              padding: '4px 8px'
            }
          }}
        >{paramDisplayName}</Typography>
      </Stack>
      <Stack ref={ref}>
        {loading ? (
          <Stack
            sx={theme => ({
              padding: '0 16px'
            })}
          >
            <TransItem/>
            <TransItem/>
            <TransItem/>
          </Stack>
        ) : data?.list.length === 0 ? (
          <Box>
            <Empty text={t('no_data')}/>
          </Box>
        ) : <Box>
          <Stack className={mobileClasses.list}
          >
            {
              data?.list.map((item) => {
                return (
                  <Stack
                    key={item.id}
                    
                    sx={theme => ({
                      padding: '0 16px',
                    })}
                    className={mobileClasses.item} direction="row" justifyContent="space-between"
                    alignItems="center">
                    <Box 
                      sx={{padding:"0 0 20px 0",marginTop:"20px", width:'100%', borderBottom:'0.5px solid rgba(16, 5, 28, 0.05)'}}
                      
                    >
                      <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Stack direction="row" gap={'12px'} justifyContent="space-between"
                          onClick={() => {
                            onSelectAddress(item)
                          }}
                        >
                          <Stack>
                            <Typography
                              sx={theme => ({
                                  fontSize: '15px',
                                  fontWeight: 500}
                              )}
                            >{item.remark}</Typography>
                            <Stack direction="row" alignItems="center" gap={'6px'}>
                              <p className={'tiny'}>{item.withdrawAddress}</p>
                              <Box
                              onClick={(e) => {
                                e.stopPropagation()
                              }}
                              >
                                <CopyButton size={14} color={theme.palette.text.tertiary} value={item.withdrawAddress} />
                              </Box>

                            </Stack>

                          </Stack>
                        </Stack>
                        <RpIcon
                          color={theme.palette.text.secondary}
                          size={20}
                          clickable
                          onClick={(e) => {
                            doConfirm(item)
                            e.stopPropagation()
                          }}
                          icon="trash" />
                      </Stack>
                    </Box>
                  </Stack>

                )
              })
            }
          </Stack>
          <Stack className={classes.loadoMore} direction="row">
            {!loading && hasMore && (
              <Box>
                <LoadMore disabled={loadingMore} loading={loadingMore} hasMore={!noMore} onClick={() => {
                  loadMore
                }}/>
              </Box>
            )}
            {/*{!hasMore && <Typography>{t('no_more_records')}</Typography>}*/}
          </Stack>
        </Box>
        }
      </Stack>

      <Box className={'fixed-button'}>
        <AppLoadingButton
          size={'large'}
          variant="contained"
          fullWidth
          onClick={() => {
            // navigate(`${RouteConstant.USER_ADDRESS_ADD}?variety_code=${paramVarietyCode}&coin=${paramCoin}&display_name=${paramDisplayName}`)
            navigate({
              pathname: RouteConstant.USER_ADDRESS_ADD,
              search: createSearchParams({
                ...Object.fromEntries(searchParams),
                variety_code: paramVarietyCode,
                coin: paramCoin,
                display_name: paramDisplayName,
              }).toString(),
            });
          }}
        >{t('add')}</AppLoadingButton>
      </Box>
    </Stack>
  </>)
}

export default AddressBook;